(function () {
  'use strict';

  var id = 'pie-chart',
    pieChartMeasures = null;

  // Add onto the wsLrs.cards module...
  angular.module('wsLrs.cards').config(['$routeProvider', function ($routeProvider) {
    // Add routes
    $routeProvider.
    //route format MUST be: card.template.name + "/" + card.id
    when('/' + id + '/:cardId', {
      templateUrl: 'modules/app/pie-chart/pie-chart-detail.html',
      controller: id + ".Detail",
      resolve: {
        cardLoader: ['CardLoader', function (CardLoader) {
          return CardLoader.loadCards();
        }]
      }
    }).when('/' + id + '/:cardId/top', {
      templateUrl: 'modules/app/pie-chart/pie-chart-card.html',
      controller: id + ".Card",
      resolve: {
        cardLoader: ['CardLoader', function (CardLoader) {
          return CardLoader.loadCards();
        }]
      }
    });
  }]).run(['CardIconMap', function (CardIconMap) {
    //Register card icon preferences ONLY IF different than default icon for card type
    CardIconMap.register({
      "pie-chart": "pie"
    });
  }]).factory(id + '.Utils', ['AggregationUtils', 'CardQueryResource', 'QueryES', 'ChartUtils', 'Utils', function (AggUtils, CardQueryResource, QueryES, ChartUtils, CentralUtils) {
    var result = {
      fetchData: function fetchData(cfg) {
        cfg = cfg || {};
        return CardQueryResource.getWithProgress("/pie-chart/data", cfg.cardId, cfg.params, cfg.cardToPreview, 'pie-chart-' + cfg.cardId);
      },
      getStatementDownloadUrl: function getStatementDownloadUrl(cardId) {
        return QueryES.queryExportUrl(cardId, true, id);
      },
      getSegmentValue: function getSegmentValue(stat, segmentBy) {
        switch (segmentBy.toLowerCase()) {
          case "count":
            return stat.count;
          case "max":
            return stat.max;
          case "min":
            return stat.min;
          case "sum":
            return stat.sum;
          default:
            return stat.avg;
        }
      },
      getPieChart: function getPieChart(data, config) {
        var segmentBy = config.segmentBy || "AVERAGE";
        config = angular.copy(config);
        var totalMeasureCount = config.measures.length;
        if (config.hiddenMeasures && config.hiddenMeasures.length) {
          var visibleMeasureCount = totalMeasureCount - config.hiddenMeasures.length;
          if (totalMeasureCount > visibleMeasureCount) {
            config.measures = _.filter(config.measures, function (m, i) {
              return config.hiddenMeasures.indexOf(i) === -1;
            });
          }
          if (data.stats.length > visibleMeasureCount) {
            data.stats = _.filter(data.stats, function (s, i) {
              return config.hiddenMeasures.indexOf(i) === -1;
            });
          }
        }
        var chart = {
          chart: {
            type: 'pie',
            plotBackgroundColor: null,
            plotBorderWidth: null,
            plotShadow: false
          },
          title: {
            text: null
          },
          tooltip: {
            headerFormat: '<div class="watershed-tooltip">',
            pointFormat: config.measures.length > 1 ? '<b>{point.name}:</b> <div>{point.percentage:.1f}% of {series.name}</div>' : '<b>{point.name}:</b> <div>{series.name}: {point.y} ({point.percentage:.1f}%)</div>',
            footerFormat: '</div>'
          },
          plotOptions: {
            pie: {
              allowPointSelect: true,
              cursor: 'pointer',
              dataLabels: {
                enabled: false
              },
              showInLegend: true
            }
          },
          series: [{
            type: 'pie',
            name: config.measures.length > 1 ? AggUtils.getDimensionInSentence(config.dimensions[0], true) : config.measures[0].name,
            data: config.measures.length > 1 ? _.chain(data.stats).map(function (s, i) {
              return {
                name: config.measures[i].name,
                color: ChartUtils.getSeriesColor(config, i, null, config.measures[i]),
                y: result.getSegmentValue(s, segmentBy)
              };
            }).value() : _.map(data.data, function (d, i) {
              return {
                name: AggUtils.getDimensionDisplay(d.values[0], config.dimensions[0]),
                color: ChartUtils.getSeriesColor(config, i),
                y: d.aggregations[0].value
              };
            })
          }]
        };
        chart.series[0].data = _.filter(chart.series[0].data, function (s) {
          return s.y > 0;
        });
        return chart;
      },
      // Returns the card's saved default sort, or the fallback sort if no default exists
      getDefaultSort: function getDefaultSort(config) {
        var fallbackSort = '-measure[0].value'; // In case no defaultSort has been set
        return CentralUtils._try(function () {
          return config.defaultSort || fallbackSort;
        }, fallbackSort);
      }
    };
    return result;
  }]).controller(id + ".CardConfiguration", ["$scope", '$controller', '$rootScope', 'Measures', function ($scope, $controller, $rootScope, Measures) {
    $scope.tempMeasures = pieChartMeasures;
    $scope.templateType = id;
    $scope.getMeasures = Measures.getCommonMeasures;
    $scope.pieChartHelpText = {
      helpTitle: 'Pie',
      detailText: "In the Pie chart section, you'll choose how you want to group data (in the Organized " + "menu) and what measures you'll want to see (using the Measures menu). Choose an option in the " + "Organized menu first, and then select as many measures as you'd like by choosing them in the " + "dropdown and clicking Add Measure. Remove a measure by clicking the X next to a selected measure. "
    };
    $controller("AggregationCardConfiguration", {
      $scope: $scope
    });

    //clear out any listerMeasures on a new explore card event
    $rootScope.$on('explore-card', function () {
      pieChartMeasures = null;
    });
  }]).controller(id + ".Card", ["$scope", "CardRegistry", id + '.Utils', 'AggregationUtils', '$routeParams', 'wsEventNames', 'ReportValidationService', function ($scope, CardRegistry, Utils, AggUtils, $routeParams, wsEvents, ReportValidationService) {
    if (!$scope.cardId && $routeParams.cardId) {
      $scope.cardId = $routeParams.cardId;
    }
    $scope.config = CardRegistry.get($scope.cardId).configuration;
    $scope.measures = $scope.config.measures;
    var validation = ReportValidationService.validate($scope.cardId);
    if (validation.hasErrors) {
      $scope.hasData = false;
      $scope.noDataMsg = validation.message;
      return;
    }
    var fetchCfg = {
      cardId: $scope.cardId,
      cardToPreview: $scope.cardToPreview,
      params: {
        "_limit": $scope.config.limit || ($scope.config.measures && $scope.config.measures.length > 1 ? 1000 : 10),
        "_offset": 0,
        "order_by": Utils.getDefaultSort($scope.config)
      }
    };
    Utils.fetchData(fetchCfg).then(function (r) {
      if ($scope.cardToPreview) {
        $scope.$emit(wsEvents.card.preview.loaded, r);
      }

      //do we use this?
      $scope.averages = r.results[0].result.stats;
      $scope.pieChart = Utils.getPieChart(r.results[0].result, $scope.config);
      $scope.defaultSummary = 'Pie chart of the top ' + Math.min(r.results[0].result.data.length, $scope.config.limit || 10) + ' ' + AggUtils.getDimensionInSentence($scope.config.dimensions[0], true) + '.';
      var measureCount = $scope.measures.length;
      var resultCount = r.results[0].result.count;
      var dataCount = r.results[0].result.data.length;
      $scope.hasData = measureCount > 0 && (measureCount > 1 && resultCount > 0 || dataCount > 0);
    }, function () {
      $scope.hasData = false;
    });
  }]).controller(id + ".Detail", ["$routeParams", "$scope", "$timeout", 'AggregationUtils', "CardRegistry", "CardUtils", "CardQueryResource", 'Utils', id + '.Utils', 'wsEventNames', "$q", 'ReportValidationService', function ($routeParams, $scope, $timeout, AggUtils, CardRegistry, CardUtils, CardQueryResource, CentralUtils, Utils, wsEvents, $q, ReportValidationService) {
    $scope.cardId = $routeParams.cardId;
    $scope.card = CardRegistry.get($scope.cardId);
    $scope.config = $scope.card.configuration;
    $scope.config = CardRegistry.get($scope.cardId).configuration;
    $scope.measures = $scope.config.measures;
    var validation = ReportValidationService.validate($scope.cardId);
    if (validation.hasErrors) {
      $scope.hasData = false;
      $scope.noDataMsg = validation.message;
      return;
    }
    var sortConfigOptions = {
      dimension: $scope.dimension,
      measures: $scope.measures
    };
    $scope.sortConfig = AggUtils.sortConfig(sortConfigOptions);
    $scope.sortConfig.setSelections($scope.config.defaultSort || $scope.sortConfig.defaultSort);
    var fetchCfg = {
      cardId: $scope.cardId,
      cardToPreview: $scope.cardId === 'preview' ? $scope.card : null,
      params: {
        "order_by": Utils.getDefaultSort($scope.config),
        "_limit": 10000 //For a pie chart, far more buckets than likely needed, but provides an upper-end
      }
    };

    // The chart itself isn't limit to just the first 100 data points so is a separate call
    // that matches the card/summary view so should be cached
    var chartFetchCfg = {
      cardId: $scope.cardId,
      cardToPreview: $scope.cardId === 'preview' ? $scope.card : null,
      params: {
        "_limit": $scope.config.limit || ($scope.config.measures && $scope.config.measures.length > 1 ? 1000 : 10),
        "_offset": 0,
        "order_by": Utils.getDefaultSort($scope.config)
      }
    };
    var dimensionLabels = AggUtils.getDimensionLabels({
      config: $scope.config,
      context: 'detailView'
    });
    var sortControls = [{
      "title": CentralUtils.capitalizeEachWord(dimensionLabels[0]),
      "options": {
        "Ascending": "dimension[0].label",
        "Descending": "-dimension[0].label"
      }
    }];
    _.each($scope.measures, function (m, i) {
      var isHidden = CentralUtils._try(function () {
        return $scope.config.hiddenMeasures.indexOf(i) > -1;
      }, false);
      if (isHidden) {
        return;
      }
      sortControls.push({
        "title": m.name,
        "options": {
          "Ascending": "measure[" + i + "].value",
          "Descending": "-measure[" + i + "].value"
        }
      });
    });
    if ($scope.config.measures.length === 1) {
      sortControls.push({
        "title": "Add to Chart"
      });
    }
    $scope.idsOnChart = [];
    $scope.$watchCollection('idsOnChart', function () {
      if (!$scope.idsOnChart || $scope.idsOnChart.length < 1) {
        return;
      }
      var dataOnChart = _.filter($scope.data.data, function (d) {
        return $scope.idsOnChart.indexOf(d.values[0].value) > -1;
      });
      $scope.pieChart = Utils.getPieChart({
        data: dataOnChart
      }, $scope.config);
    });
    $scope.isOnChart = function (d) {
      return $scope.idsOnChart.indexOf(d.dimensions[0].value) >= 0;
    };
    $scope.checkBox = function (d) {
      if ($scope.isOnChart(d)) {
        $scope.idsOnChart.splice($scope.idsOnChart.indexOf(d.dimensions[0].value), 1);
      } else {
        $scope.idsOnChart.push(d.dimensions[0].value);
      }
    };
    var fetchAllData = $q.all([Utils.fetchData(chartFetchCfg), Utils.fetchData(fetchCfg)]);
    fetchAllData.then(function (responses) {
      // Handle Chart Data
      var chartResponse = responses[0];
      var response = responses[1];
      if ($scope.config.measures.length > 1) {
        $scope.pieChart = Utils.getPieChart(chartResponse.results[0].result, $scope.config);
      } else {
        $scope.idsOnChart = _.map(_.first(chartResponse.results[0].result.data, $scope.config.limit || 10), function (d) {
          return d.values[0].value;
        });
      }
      if ($scope.cardToPreview) {
        $scope.$emit(wsEvents.card.preview.loaded, response);
      }

      // Handle Leaderboard Data (partial results)
      $scope.data = response.results[0].result;
      $scope.leaderboardDefinition = {
        data: {
          allAttempts: {
            results: _.map($scope.data.data, function (d) {
              return {
                dimensionDisplay: AggUtils.getDimensionDisplay(d.values[0], $scope.config.dimensions[0]),
                dimensions: d.values,
                measures: d.aggregations.map(function (agg, idx) {
                  return Object.assign(agg, {
                    display: AggUtils.getMeasureValueDisplay(agg, $scope.measures[idx])
                  });
                }).filter(function (m, i) {
                  return CentralUtils._try(function () {
                    return $scope.config.hiddenMeasures.indexOf(i) === -1;
                  }, true);
                }),
                checkBox: $scope.config.measures.length > 1 ? false : $scope.checkBox,
                isOnChart: $scope.isOnChart
              };
            })
          },
          firstAttempt: {
            results: []
          },
          lastAttempt: {
            results: []
          },
          bestAttempt: {
            results: []
          }
        },
        templateUrl: 'modules/app/pie-chart/leaderboard.html',
        sortControls: sortControls,
        orderByCallback: function orderByCallback(sort) {
          var isDimSort = sort.indexOf("dimension") > -1,
            isLabel = sort.indexOf("label") > -1,
            index = Number(sort.replace(/(^.*\[|\].*$)/g, ''));
          return function (l) {
            var val = (isDimSort ? l.dimensions : l.measures)[index][isLabel ? 'label' : 'value'];
            // Sorting has odd handling of undefined, so force to null
            if (val === undefined) {
              val = null;
            }
            if (typeof val === 'string') {
              var d = new Date(val);
              if (d.toString() !== 'Invalid Date') {
                return d;
              }
            }
            return val;
          };
        },
        sortBy: Utils.getDefaultSort($scope.config),
        listerControls: {
          pageSize: 50
        }
      };
      $scope.hasData = response.results[0].result.data.length > 0 && $scope.measures.length > 0;
      $scope.pagenote.setReportMetadata(response);
    }, function () {
      $scope.hasData = false;
    });
    CardUtils.setNavElements($scope, $scope.cardId, $scope.cardId);
    $scope.subDetails = [{
      text: "Download data",
      downloadData: true,
      tooltip: "Download data tables",
      href: CardQueryResource.getDownloadUrl('pie-chart/csv', $scope.cardId, $scope.config)
    }, {
      text: "Download interaction statements",
      downloadData: true,
      tooltip: "Download interaction statements",
      callback: Utils.getStatementDownloadUrl($scope.cardId === 'preview' ? $scope.config : $scope.cardId)
    }];
    $scope.pagenote = {
      "clearCacheAction": "cards/" + $scope.cardId + "/cache"
    };
  }]);
})();
